<template>
    <v-flex>
        <!-- Oda Tipleri Select -->
        <v-flex>
            <label for="oda-tipleri">Oda Tipi Seç:</label>
            <v-select v-model="selectedOdaTip" :items="OdaTipleri" item-text="Aciklama" :return-object="true"
                id="oda-tipleri">

            </v-select>
            <v-btn @click="ekleOdaTipi">Ekle</v-btn>
        </v-flex>

        <!-- Seçilen Oda Tipleri ve Formlar -->
        <v-layout v-for="oda in SelectedOdaTipleri" :key="oda.id" class="oda-form" wrap row="" col="">
            <v-flex xs11 sm11 md11 lg11>
                <h3>{{ oda.id + 1 }}. {{ oda.Aciklama }} Oda</h3> 
            </v-flex>
            <v-flex xs1 sm1 md1 lg1>
                <v-icon color="warning"  @click="odaSil(oda.id)">delete</v-icon>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12>
            <!-- Yetişkin Formları -->
            <PersonForm v-for="(yetiskin, index) in oda.formlar.yetiskin" :key="`yetiskin-${oda.id}-${index}`"
                :index="index + 1" :odaId="oda.id" :person.sync="oda.formlar.yetiskin[index]" :person-type="'Yetişkin'" @form-valid="validForm"/>

            <!-- Çocuk Formları -->
            <PersonForm v-for="(cocuk, index) in oda.formlar.cocuk" :key="`cocuk-${oda.id}-${index}`" :index="index + 1"
                :person.sync="oda.formlar.cocuk[index]" :odaId="oda.id" :person-type="'Çocuk'" @form-valid="validForm" />
            </v-flex>
        </v-layout>
    </v-flex>
</template>

<script>
import PersonForm from './PersonForm.vue';
import tool from '../../coper/tools';

export default {
    components: {
        PersonForm,
    },
    data() {
        return {
            OdaTipleri: [],
            selectedOdaTip: null,
            selectedOdalar : []
        };
    },
    props: {
        SelectedOdaTipleri: {
            type: Array,
            required: true,
        },
    },
    methods: {
        OdaTipleriGetir() {
            var prm = {
                Ara: null
            };
            tool.http_post(this, "OdaTipleriList", prm).then(
                (response) => {
                    response.body.data.forEach(odaTipi => {
                        this.OdaTipleri.push(odaTipi);
                        if (odaTipi.AltOdaTipleri !== null)
                            odaTipi.AltOdaTipleri.forEach(altOdaTipi => {
                                this.OdaTipleri.push(altOdaTipi);
                            })
                    });
                },
                (response) => {
                    //   this.status = tool.responseToStatus(response);
                }
            );
        },
        ekleOdaTipi() {
            if (this.selectedOdaTip && !this.selectedOdalar.some(oda => oda.id === this.selectedOdaTip.id)) {
                this.selectedOdalar.push({
                    ...this.selectedOdaTip,
                    id: this.selectedOdalar.length,
                    formlar: {
                        yetiskin: Array.from({ length: this.selectedOdaTip.Yetiskin }, (element,index) => ({
                            id:index,
                            KisiTip:0,
                            Ad: '',
                            Soyad: '',
                            TcKimlikNo: '',
                            Sira:index,
                            Adres: '',
                            DogumTarihi: '',
                            Cinsiyet: '',
                            Telefon: '',
                            CepTelefonu: '',
                            Email: '',
                            valid:false
                        })),
                        cocuk: Array.from({ length: this.selectedOdaTip.Cocuk1 }, (element,index) => ({
                            id:index + this.selectedOdaTip.Yetiskin,
                            KisiTip:1,
                            Ad: '',
                            Soyad: '',
                            TcKimlikNo: '',
                            Sira:this.selectedOdaTip.Yetiskin + index,
                            Adres: '',
                            DogumTarihi: '',
                            Cinsiyet: '',
                            Telefon: '',
                            CepTelefonu: '',
                            Email: '',
                            valid:false
                        })),
                        bebek: Array.from({ length: this.selectedOdaTip.Cocuk2 }, (element,index) => ({
                            KisiTip:2,
                            id:index + this.selectedOdaTip.Yetiskin + this.selectedOdaTip.Cocuk1,
                            Ad: '',
                            Soyad: '',
                            Sira:this.selectedOdaTip.Yetiskin + this.selectedOdaTip.Cocuk1 + index,
                            TcKimlikNo: '',
                            Adres: '',
                            DogumTarihi: '',
                            Cinsiyet: '',
                            Telefon: '',
                            CepTelefonu: '',
                            Email: '',
                            valid:false
                        })),
                    },
                });
                this.$emit("update-odalar", this.selectedOdalar);

            }
        },
        validForm(obj){
            var oda = this.selectedOdalar.filter(x => x.id === obj.odaId)[0];
            switch (obj.kisiTip) {
                case 0:
                    oda.formlar.yetiskin.find(x => x.id === obj.id).valid = obj.isValid;
                    break;
                case 1:
                    oda.formlar.cocuk.find(x => x.id === obj.id).valid = obj.isValid;
                    break;
                case 2:
                    oda.formlar.bebek.find(x => x.id === obj.id).valid = obj.isValid;
                    break;
                default:
                    break;
            }
            this.selectedOdalar.find(x => x.id == obj.odaId).formlar.yetiskin = oda.formlar.yetiskin
            this.selectedOdalar.find(x => x.id == obj.odaId).formlar.cocuk = oda.formlar.cocuk
            this.selectedOdalar.find(x => x.id == obj.odaId).formlar.bebek = oda.formlar.bebek
        },
        odaSil(id){
            this.selectedOdalar = this.selectedOdalar.filter(x => x.id !== id);
            this.$emit("update-odalar", this.selectedOdalar);
        }
    },
    mounted() {
        this.OdaTipleriGetir();
    },
};
</script>

<style scoped>
.oda-form {
    margin-bottom: 20px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
}
</style>